document.addEventListener("turbolinks:load", function() {
  var element =  document.getElementById('map');
  if (typeof(element) != 'undefined' && element != null)
  {

    var map = new GMaps({
      div: '#map',
      lat: 46.78,
      lng: 8.29,
    });
    window.map = map;
    // var marker = map.addMarker({
    //   lat: 46.78,
    //   lng: 8.29,
    //   title: "Test",
    //   infoWindow: {
    //     content: `<p>Test2</p>`
    //   }
    // });

    var customers = JSON.parse(document.querySelector("#map").dataset.customers);
    window.customers = customers;

    var bounds = new google.maps.LatLngBounds();

    var marker = map.addMarker({
      lat: 46.3111533,
      lng: 7.5775816,
      icon: "https://indianaer.herokuapp.com/assets/wundaerland_marker_home-8b7ed39435af76fd2b389110c51d3aa73fdb380edfd3f5060b706bed516205e5.png",
      infoWindow: {
        content: "<p><strong>Wundärland GmbH</strong><br>Weinbergstrasse 12<br>3970 Salgesch</p>"
      },
      zIndex: 1000
    });

    bounds.extend(marker.position);

    customers.forEach(function(customer) {
      if (customer.latitude && customer.longitude ) {
        if (customer.customer_type == "Private") {
          var marker = map.addMarker({
            lat: customer.latitude,
            lng: customer.longitude,
            icon: "https://indianaer.herokuapp.com/assets/wundaerland_marker-150dc4648425c07687309f898b14ae8fee5bacc4b446d5962ea4592951e1f473.png",
            infoWindow: {
              content: `<p><a href='/customers/${customer.id}'>${customer.prename} ${customer.name}<br>${customer.street} ${customer.street_number}<br>${customer.zip} ${customer.town}</a></p>`
            }
          });
          bounds.extend(marker.position);
        } else if (customer.customer_type == "Gastro") {
          var marker = map.addMarker({
            lat: customer.latitude,
            lng: customer.longitude,
            icon: "https://indianaer.herokuapp.com/assets/wundaerland_marker_gastro-4a6d393dfd518c4206e25c7635b97f8b6b698349685cb137e49e9405763b2826.png",
            infoWindow: {
              content: `<p><strong>${customer.company_name}</strong><br><a href='/customers/${customer.id}'>${customer.prename} ${customer.name}<br>${customer.street} ${customer.street_number}<br>${customer.zip} ${customer.town}</a></p>`
            }
          });
          bounds.extend(marker.position);
        } else {
          var marker = map.addMarker({
            lat: customer.latitude,
            lng: customer.longitude,
            icon: "https://indianaer.herokuapp.com/assets/wundaerland_marker_company-a33e0409751c7a4a476e176474d6b04e479d7033f80c6ec688c2af6eb6a7bd26.png",
            infoWindow: {
              content: `<p><strong>${customer.company_name}</strong><br><a href='/customers/${customer.id}'>${customer.prename} ${customer.name}<br>${customer.street} ${customer.street_number}<br>${customer.zip} ${customer.town}</a></p>`
            }
          });
          bounds.extend(marker.position);
        }
      }
    });

    map.fitBounds(bounds);
  }
});
